export default __webpack_public_path__ + "static/media/planet-mars.f9dc1ca4.svg";